const NOTAFISCAL = {
  titulo: 'Regras de padronização de nota fiscal',
  cartaoTitulo: 'Nota Fiscal',
  cartaoSubtitulo: 'Faça o upload da nota fiscal do parceiro que deseja padronizar.',
  formularioTituloNovaRegra: 'Nova regra',
  formularioTituloEditarRegra: 'Editar Regra',
  formularioSubtitulo: 'Abaixo você conseguirá selecionar os campos do template padrão e adicionar condições/ações para que a padronização aconteça.',
  formularioAcao: 'Adicione a ação que deseja para que esta regra funcione.',
  formularioCondicao: 'Adicione condições para essa regra, se houver.',
  formularioTipoTemplate: 'Quando o campo do template padrão for'
}

const NOTAFISCAL_INFO = {
  tituloRegra: 'Adicione um título para regra que você irá criar',
  tipoPlanilha: 'Selecione o tipo de nota fiscal linhas/colunas',
  tipoTemplate: 'Selecione aqui o campo que vai ser considerado para a condição e ação',
  prioridade: 'Informe a prioridade da regra',
  condicao: {
    tipoCondicao: 'Selecione aqui a coluna da nota fiscal do parceiro que deseja adicionar condições',
    tipoOperacaoCondicao: 'Selecione a operação que deseja para a condição desta regra',
    tipoParametroCondicao: 'Insira aqui o texto/valor que será o critério da condição'
  },
  acao: {
    tipoOperacaoAcao: 'Selecione a operação que deseja para a ação desta regra',
    aritmetica: 'Selecione a operação para {0} linhas/colunas ou valores',
    concatenar: 'Selecione a operação para unir no ínicio ou no fim um critério',
    considerar: 'Selecione a operação para considerar um critério',
    separador: 'Selecione a operação para separar por vírgula ou ponto uma coluna',
    substituir: 'Substituir uma coluna por um critério',
    parametroColuna: 'Selecione a coluna que deseja da nota fiscal do parceiro',
    parametroCriterio: 'Insira aqui o texto/valor que será o critério da ação',
    tipoParametro: 'Selecione coluna nota fiscal do parceiro ou critério digitável'
  }
}

const NOTAFISCAL_MODAL = {
  titulo: 'Pré visualização de Nota Fiscal'
}

const NOTAFISCAL_DICA = {
  dica: 'Clique aqui para ver dicas que podem te ajudar.'
}

const NOTAFISCAL_LABELS_ACAO = {
  dado: 'Coluna'
}
export { NOTAFISCAL, NOTAFISCAL_INFO, NOTAFISCAL_DICA, NOTAFISCAL_MODAL, NOTAFISCAL_LABELS_ACAO }
